import { HeaderW, PageTitle } from './styled';

interface PageHeaderBoldTitleProps {
  title: string;
  onClickCloseIcon?: () => void;
  buttonPosition?: 'fixed' | 'static' | 'relative' | 'absolute';
  classNames?: string;
  withCloseBtn?: boolean;
}

export const PageHeaderBoldTitle = ({ title, classNames }: PageHeaderBoldTitleProps) => {
  return (
    <HeaderW>
      <PageTitle className={classNames} variant="h1">
        {title}
      </PageTitle>
    </HeaderW>
  );
};
